module.exports = __webpack_public_path__ + "static/media/testimoni-1.501dda4e.png";